module.exports = __webpack_public_path__ + "static/bsas008-2356c79085104e8b3439fc77c0d56afd.jpg";